export default (typeof global != 'undefined' ? global : window);